import React, { useEffect, useState } from 'react';
import Button from '../../Button/Button';
import Modal from '../Modal/Modal';
import styles from "./SummaryModal.module.scss";
import Checkbox from '../../Formik/Checkbox/Checkbox';
import ThanksModal from '../ThanksModal/ThanksModal';
import { getBankDetailsAction } from '../../../../features/user/userSlice';
import { useDispatch } from 'react-redux';


const SummaryModal = ({ show, handleClose }) => {
	const dispatch = useDispatch();
	const [showThanks, setShowThanks] = useState(false);
	const [bankDetail, setBankDetails] = useState([]);

	  const getBankDetails = async () => {
		try {
		  const response = await dispatch(getBankDetailsAction());
		  if (response?.status === 200) {
			const details = response.data.data;
			setBankDetails(details);
		  }
		} catch (error) {
		  console.log("Something went wrong:", error);
		}
	  };

	  useEffect(() => {
		  getBankDetails();

		  }, []);
	return (
    <>
      <Modal
        className={styles.summary_modal}
        show={show}
        handleClose={handleClose}
        title="Summary"
      >
        <div className={styles.direct_sec}>
          <h5>Bank info.</h5>
          <ul>
            {[
              { label: "Name", value: bankDetail?.bank_name },
              {
                label: "Routing Number (ABA)",
                value: bankDetail?.routing_number,
              },
              { label: "Account Number", value: bankDetail?.account_number },
            ].map(
              (item, index) =>
                item.value && (
                  <li key={index}>
                    <p>{item.label}:</p>
                    <p>{item.value}</p>
                  </li>
                )
            )}
          </ul>
        </div>
        <div className={styles.direct_sec}>
          <h5>Bank info.</h5>
          <ul>
            {[
              { label: "Name", value: bankDetail?.account_holder_name },
              // { label: "Address", value: "Somewhere on earth" },
            ].map((item, index) => (
              <li key={index}>
                <p>{item.label}:</p>
                <p>{item.value}</p>
              </li>
            ))}
          </ul>
        </div>
        <div className={styles.summary_check}>
          <Checkbox
            name="disclaimer"
            label="Disclaimer: I’ve ensure that details entered here exactly match my bank account. Any inaccurate information will result in loss of funds. "
          />
        </div>
        <Button
          fluid
          variant="secondary_btn"
          className={styles.submit_btn}
          onClick={() => {
            handleClose();
            setShowThanks(true);
          }}
        >
          Continue
        </Button>
      </Modal>
      <ThanksModal show={showThanks} handleClose={() => setShowThanks(false)} />
    </>
  );
}

export default SummaryModal